import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router";

export function Forbidden() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const denied = params.get("denied") || "";

  // Clean the slug and display in friendly format (e.g. "TST000-J01")
  const deniedLabel = denied
    .replace(/[^a-z0-9-]/gi, "")
    .slice(0, 64)
    .toUpperCase();

  return (
    <Box sx={{ py: 10, textAlign: "center", maxWidth: 600, mx: "auto" }}>
      <Typography variant="h3" fontWeight={700} gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
        {deniedLabel ? `You don’t have access to ${deniedLabel}.` : "You don’t have access to this course."}
        <br />
        Please check that you’re signed in with the correct account or contact support.
      </Typography>
      <Button
        variant="contained"
        sx={{ bgcolor: "#004f77", "&:hover": { bgcolor: "#0a6a9e" } }}
        onClick={() => navigate("/")} // No reference to `denied`
      >
        Back to Courses
      </Button>
    </Box>
  );
}
